import { useSelector } from 'react-redux';
import { useAppDispatch } from 'store';
import { loadFlowProjectsAction } from 'store/reducers/adminFlows/actions';
import { useEffect } from 'react';
import { getFlowProjects } from 'store/reducers/adminFlows/getters';
import { NoopType } from 'types/global';

interface useFlowProjectsListInterface {
  id?: string;
  onClose?: NoopType;
}

export const useFlowProjectsList = ({ id, onClose }: useFlowProjectsListInterface) => {
  const dispatch = useAppDispatch();
  const { loading, flowProjectsList } = useSelector(getFlowProjects);

  useEffect(
    () => {
      if (id) {
        dispatch(loadFlowProjectsAction({ flowId: id }));
        onClose && onClose();
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [id, onClose],
  );

  return { loading, flowProjectsList };
};
